import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { AsyncFormValidation } from '../../interceptors/error.interceptor';
import { Pagination } from '../../models/pagination.interface';
import { QueryGet } from '../../types/query-types';
import { OptionSelect } from '../../../shared/components/search-select/search-select';
import { LifePlan, LifePlanDTO } from '../../models/lifeplan.interface';
import { RequestService } from '../request/request';

@Injectable({
  providedIn: 'root',
})
export class LifeplanService {
  httpOptions = {
    headers: new HttpHeaders({}),
  };

  urlPath = environment.service_1 + 'life-plans/';
  url = environment.service_1 + 'all-life-plans/';

  public asyncErrorValidation = new BehaviorSubject<AsyncFormValidation | null>(null);
  asyncErrorValidation$ = this.asyncErrorValidation.asObservable();

  private selectedlifeplan = new BehaviorSubject<LifePlan | null>(null);
  selectedlifeplan$ = this.selectedlifeplan.asObservable();

  private lifeplans = new BehaviorSubject<LifePlan[]>([]);
  lifeplans$ = this.lifeplans.asObservable();

  constructor(
    private http: HttpClient,
    private requestService: RequestService,
  ) {}

  setLifePlan(lifeplan: LifePlan) {
    this.selectedlifeplan.next(lifeplan);
  }

  setLifePlans(lifeplans: LifePlan[]) {
    this.lifeplans.next(lifeplans);
  }

  removeLifePlanSelected() {
    this.selectedlifeplan.next(null);
  }

  createLifeplan(lifeplan: LifePlanDTO) {
    return this.http.post<LifePlan>(this.urlPath, lifeplan).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  UpdateLifeplan(id: number, lifeplan: LifePlanDTO & { id: number }) {
    return this.http.put<LifePlan>(this.urlPath + id + '/', lifeplan).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  getLifeplan(query: QueryGet): Observable<Pagination<LifePlan[]>> {
    return this.requestService.get<LifePlan[]>(this.urlPath, query);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(this.urlPath + id + '/');
  }

  getLifeplans(): Observable<LifePlan[]> {
    return this.http.get<LifePlan[]>(this.url, {
      headers: this.httpOptions.headers,
    });
  }

  getOptionLifeplan(lifeplan: LifePlan[]): OptionSelect[] {
    return lifeplan.map((item: LifePlan) => {
      return {
        value: item.id ?? '',
        label: item.name,
      };
    });
  }
}
